import ms1 from '../../assets/marshall/ms1.png';
import ms2 from '../../assets/marshall/ms2.png';
import ms3 from '../../assets/marshall/ms3.png';
import ms4 from '../../assets/marshall/ms4.png';
import ms5 from '../../assets/marshall/ms5.png';
import ms6 from '../../assets/marshall/ms6.png';

const marshallSpeakers = [
  {
    id: 1,
    image: ms1,
    name: 'WILLEN',
  },
  {
    id: 2,
    image: ms2,
    name: 'EMBERTON',
  },
  {
    id: 3,
    image: ms3,
    name: 'EMBERTON II',
  },
  {
    id: 4,
    image: ms4,
    name: 'STOCKWELL II',
  },
  {
    id: 5,
    image: ms5,
    name: 'KILBURN II',
  },
  {
    id: 6,
    image: ms6,
    name: 'TUFTON',
  },
];

export default marshallSpeakers;
